import {
  FETCH_REWARDS_FAILURE,
  FETCH_REWARDS_REQUEST,
  FETCH_REWARDS_SUCCESS,
  UPDATE_REWARDS_FAILURE,
  UPDATE_REWARDS_REQUEST,
  UPDATE_REWARDS_SUCCESS,
} from "../../actions/actionTypes/reward";
import { RewardsLedgerItem } from "../../../../types/db-types";
import { RewardsActions } from "../../actions/actionCreators/reward";

export interface RewardsData {
  rewards: RewardsLedgerItem[];
  totalPointsCurrent: number;
  totalPointsHistorical: number;
  pointsToReward: number;
  rewardAmount: number;
  rewardAmountPendingUse: number;
  ledger_items: RewardsLedgerItem[];
  userAppState: string;
}

interface State {
  data: RewardsData | {};
  loading: boolean;
  error: any | string | null;
}

const initialState: State = {
  data: {},
  error: null,
  loading: false,
};

export const reward = (state = initialState, action: RewardsActions) => {
  switch (action.type) {
    case FETCH_REWARDS_REQUEST:
    case UPDATE_REWARDS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_REWARDS_SUCCESS:
      return {
        ...state,
        data:
          Object.keys(action.payload).length > 0
            ? {
                ...state.data,
                totalPointsCurrent: action.payload?.resident?.total_points_current,
                totalPointsHistorical: action.payload?.resident?.total_points_historical,
                pointsToReward: action.payload?.property?.rewards_programs[0]?.points_to_reward,
                rewardAmount: action.payload?.property?.rewards_programs[0]?.reward_amount,
                rewardAmountPendingUse: action.payload?.resident?.rewardAmountPendingUse,
                ledger_items: action.payload?.resident?.ledger_items,
                userAppState: action?.payload?.property?.user_app_state,
              }
            : {},
        error: null,
        loading: false,
      };
    case UPDATE_REWARDS_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case FETCH_REWARDS_FAILURE:
    case UPDATE_REWARDS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
